var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloggersWriters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(1510 1474)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95827",
    "data-name": "Mask Group 95827",
    transform: "translate(-1510 -1474)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172082",
    "data-name": "Group 172082",
    transform: "translate(1518 1481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172081",
    "data-name": "Group 172081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172079",
    "data-name": "Group 172079",
    transform: "translate(5.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172109",
    "data-name": "Path 172109",
    d: "M12.43,1.63a5.184,5.184,0,1,0,5.19,5.177A5.187,5.187,0,0,0,12.43,1.63Z",
    transform: "translate(-7.24 -1.63)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172080",
    "data-name": "Group 172080",
    transform: "translate(0 10.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172110",
    "data-name": "Path 172110",
    d: "M16.335,9.991l-.362-.078-.311.181a4,4,0,0,1-3.961,0L11.377,9.9l-.362.091a11.529,11.529,0,0,0-7.766,6.226l-.259.544.375.453a13.11,13.11,0,0,0,10.1,4.918l.945-2.977.091-.311.233-.22,6.3-6.316A11.523,11.523,0,0,0,16.335,9.991Z",
    transform: "translate(-2.99 -9.9)",
    fill: "#E39DFF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_172111",
    "data-name": "Path 172111",
    d: "M23.538,12.716c-.1-.116-.22-.22-.324-.324a2.4,2.4,0,0,0-3.313.078L13.067,19.3l-1.32,4.155a.565.565,0,0,0,.712.712l4.168-1.307L23.46,16.03A2.4,2.4,0,0,0,23.538,12.716Zm-10.381,9.19.557-1.747a4.215,4.215,0,0,1,2.11,2.045l-1.8.57Zm9.462-8.866c.091.091.181.168.272.272a1.53,1.53,0,0,1-.052,2.11l-.259.259-2.317-2.317.259-.259A1.489,1.489,0,0,1,22.619,13.04Z",
    transform: "translate(-0.421 1.353)",
    fill: "#E39DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloggersWriters);
export default __webpack_public_path__ + "static/media/bloggers_writers.6707c7a5588f40a8005ed0fd8cf217f7.svg";
export { ForwardRef as ReactComponent };